import { ApolloError } from '@apollo/client';

import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';
import { readableDate } from '@occc-app/lib/format';
import { Segment } from '@occc/feat-segments';
import { TableField, DataTable, Row } from '@occc/ui-design-system';

type SegmentsProps = {
  segments: Segment[];
  error?: ApolloError;
  loading: boolean;
  paginationProps: IPaginationProps;
  onSegmentsClick: (id: string) => void;
};

const makeFields: (segment: Segment) => TableField[] = (segment) => [
  {
    label: 'Name',
    value: segment.name,
  },
  {
    label: 'Date',
    value: readableDate(segment.createdAt),
  },
];

const headers = [{ label: 'Name' }, { label: 'Date' }];

const Segments = (props: SegmentsProps) => {
  const { segments, error, loading, paginationProps, onSegmentsClick } = props;

  const rows: Row[] | null | undefined = segments?.map((segment) => {
    const fields = makeFields(segment);
    return {
      key: segment.uuid,
      fields,
      onClick() {
        onSegmentsClick(segment.uuid);
      },
    };
  });

  return (
    <DataTable
      headers={headers}
      error={error}
      loading={loading}
      paginationProps={paginationProps}
      rows={rows}
    />
  );
};

export default Segments;
